import {
  createRoutesFromElements,
  createBrowserRouter,
  Route,
  Outlet,
} from 'react-router-dom';
import { App } from './pages/app';
import { Authenticated } from './pages/authenticated';
import { Error } from './pages/error';
import { Inventories } from './pages/inventories';
import { Inventory } from './pages/inventory';
import { InventoryHome } from './pages/inventory-home';
import { Pathways } from './pages/pathways';
import { Pathway } from './pages/pathway';
import { PathwaySimulation } from './pages/pathway-simulation';
import { PathwayAssumptions } from './pages/pathway-assumptions';
import { PathwayInterventionsNew } from './pages/pathway-interventions-new';
import { PathwayScenarios } from './pages/pathway-scenarios';
import { PathwayScenario } from './pages/scenario';
import { Baseline } from './pages/baseline';
import { Gpc } from './pages/gpc';
import { Disclosures } from './pages/disclosures';
import { Disclosure } from './pages/disclosure';
import { Scenarios, Scenario } from './pages/scenarios';
import { PathwayScenarioSimulation } from './pages/scenario-simulation';
import { PathwayScenarioAssumptions } from './pages/scenario-assumptions';
import { PathwayScenarioInterventionsNew } from './pages/scenario-interventions-new';
import { ErrorNotFound } from './pages/error-not-found';
import { ErrorServer } from './pages/error-server';
import { ErrorUnknown } from './pages/error-unknown';
import { Permissions } from './pages/permissions';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      errorElement={<ErrorNotFound />}
      element={
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <Outlet />
        </QueryParamProvider>
      }
    >
      <Route path='/errors/not-found' element={<ErrorNotFound />} />
      <Route path='/errors/server' element={<ErrorServer />} />
      <Route path='/errors/unknown' element={<ErrorUnknown />} />
      <Route path='/' element={<Authenticated />} errorElement={<Error />}>
        <Route index element={<Inventories />} handle={{ type: 'emissions' }} />
        <Route
          path='communities'
          index
          element={<Inventories />}
          handle={{ type: 'emissions' }}
        />
        <Route
          path='/communities/:inventoryId'
          element={<Inventory />}
          errorElement={<Error />}
        >
          <Route element={<App />} errorElement={<Error />}>
            <Route errorElement={<Error />}>
              <Route
                index
                element={<InventoryHome />}
                handle={{ type: 'inventory' }}
              />
              <Route
                path='pathways'
                element={<Pathways />}
                handle={{ type: 'pathways', crumb: 'pathways' }}
              />
              {/* The legacy pathway surface, reachable via the pinned
                  "Legacy pathways" entry on the new Pathways list. The bare
                  `pathways` URLs belong to the new product; legacy is
                  qualified by its `pathway-scenarios` code name. */}
              <Route
                path='pathway-scenarios'
                element={<PathwayScenarios />}
                handle={{ type: 'pathway-scenarios', crumb: 'pathways' }}
              />
              <Route
                path='baseline'
                element={<Baseline />}
                handle={{ type: 'baseline', crumb: 'baseline' }}
              />
              <Route
                path='gpc'
                element={<Gpc />}
                handle={{ type: 'gpc', crumb: 'gpc' }}
              />
              <Route
                path='disclosures'
                element={<Disclosures />}
                handle={{ type: 'disclosures', crumb: 'disclosures' }}
              />
              <Route
                path='disclosures/:disclosureId'
                element={<Disclosure />}
                handle={{ type: 'disclosures', crumb: 'disclosure' }}
              />
              <Route
                path='scenarios'
                element={<Scenarios />}
                handle={{ type: 'scenarios', crumb: 'scenarios' }}
              />
              <Route
                path='scenarios/:scenarioId'
                element={<Scenario />}
                handle={{ type: 'scenarios', crumb: 'scenario' }}
              />
              <Route
                path='pathways/:pathwayId'
                element={<Pathway />}
                handle={{ type: 'pathways', crumb: 'pathway' }}
              >
                <Route
                  index
                  element={<PathwaySimulation />}
                  handle={{ type: 'pathways' }}
                />
                <Route
                  path='interventions/:interventionKey'
                  element={<PathwayAssumptions />}
                  handle={{ type: 'pathways', crumb: 'assumptions' }}
                />
                <Route
                  path='interventions/new/:category'
                  element={<PathwayInterventionsNew />}
                  handle={{ type: 'pathways', crumb: 'assumptions' }}
                />
              </Route>
              <Route
                path='pathway-scenarios/:scenarioId'
                element={<PathwayScenario />}
                handle={{ type: 'pathway-scenarios', crumb: 'scenario' }}
              >
                <Route
                  index
                  element={<PathwayScenarioSimulation />}
                  handle={{ type: 'pathway-scenarios' }}
                />
                <Route
                  path='interventions/:interventionKey'
                  element={<PathwayScenarioAssumptions />}
                  handle={{ type: 'pathway-scenarios', crumb: 'assumptions' }}
                />
                <Route
                  path='interventions/new/:category'
                  element={<PathwayScenarioInterventionsNew />}
                  handle={{ type: 'pathway-scenarios', crumb: 'assumptions' }}
                />
              </Route>
              <Route
                path='access'
                element={<Permissions />}
                handle={{ type: 'access' }}
              />
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>,
  ),
);

export { router };
